import React, { useEffect, useState } from "react";
import Select from 'react-select'
import CryptoJS from 'crypto-js';
import {  SlTabGroup, SlTab, SlSelect, SlOption, SlDrawer } from "@shoelace-style/shoelace/dist/react";
import closeSvg from "../../assets/images/uncheck.svg";
import { useNavigate } from "react-router-dom";
import bellSvg from "../../assets/images/bell.svg";
import callSvg from "../../assets/images/callp.svg";
import mikeSvg from "../../assets/images/mike.svg";
import recordSvg from "../../assets/images/record.svg";
import historySvg from "../../assets/images/history.svg";
import filterSvg from "../../assets/images/filter.svg";
import AccordionSales from "./AccordionSales";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import AddPOC from "./AddPOC";
import CampaignInfo from "./CampaignInfo";
import Interaction from "./Interaction";
import API from "../../services/api";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { InteractionStatus, roles, alphabets, BrandsTypes } from "../../utils/constants";
import InteractionHistory from "./InteractionHistory";
import { ScrollContainer } from "react-indiana-drag-scroll";
import { useDispatch, useSelector } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import AddRemainder from "./AddRemainder";
import { getGenerateUrl } from "../../utils/constants";
import { brandLabels } from "../../utils/constants";
import { format } from "date-fns";
import { Toast } from "../../shared/Toast";
import W2nSvg from '../../assets/images/way2news.svg'
import "./AccountManagement.scss";

function calculateDaysAgo(date, days = null) {
  if (!date) {
    return '-';
  }

  const inputDate = new Date(date * 1000);
  inputDate.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const difference = today.getTime() - inputDate.getTime();

  let daysDifference = Math.floor(difference / (1000 * 60 * 60 * 24));
  daysDifference = daysDifference < 0 ? 0 : daysDifference;

  if (days !== null) {
    return daysDifference;
  }

  if (daysDifference < 30) {
    return `${daysDifference} day${daysDifference !== 1 ? 's' : ''} ago`;
  } else {
    const monthsDifference = Math.floor(daysDifference / 30);
    return `${monthsDifference} month${monthsDifference !== 1 ? 's' : ''} ago`;
  }
}

function AccountManagement() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  dispatch(SetComponentId(33));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  const [addPoc, setAddPoc] = useState(false);
  const [brand, setBrand] = useState();
  const [addCampaign, setAddCampaign] = useState(false);
  const [addInteraction, setAddInteraction] = useState(false);
  const [brands, setBrands] = useState([]);
  const [allBrands,setAllBrands]= useState([]);
  const [loader, setLoader] = useState(false);
  const [history, setHistory] = useState(false);
  const [brandOptions, setBrandOptions] = useState([]);
  const searchWord = useSelector((state) => state.Head.adssearch);
  const [addRemainder, setAddRemainder] = useState(false);
  const [previousDay, setPreviousDay] = useState('0');
  const [selectedList, setSelectedList] = useState(localStorage.getItem("selectedSalesList") && salesUsersList?.length > 1 &&
  JSON.parse(localStorage.getItem("selectedSalesList")).length
  ? salesUsersList.filter((item) =>
      JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
        item.value
      )
    )
  : salesUsersList?.length > 1 ? [] : []);
  const [salesPerson_id, setSalesPerson_id] = useState(
    salesUsersList?.length > 1 ? localStorage.getItem("selectedSalesList") &&
      JSON.parse(localStorage.getItem("selectedSalesList")).length
      ? salesUsersList.filter((item) =>
          JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
            item.value
          )
        )[0]?.value || -1
      : salesUsersList[0]?.value
    : -1);
  const [interactSort, setInteractSort] = useState(false)
  const [showFilter, setShowFilter] = useState(false);
  const [activeStatus, setActiveStatus] = useState(true)
  console.log(activeStatus, typeof activeStatus)
  
  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
        salesUsersList.map((item) =>{
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )]);
  const [searchFilter, setSearchFilter] = useState('')
  const [showUsersFilter, setShowUsersFilter] = useState( false
    // JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false
  )
  const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)
  const fetchBrands = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/accountManagement/getClientDetails",
        method: "POST",
        responseType: "json",
        data: {
          search: searchWord,
          previousDay,
          sales_id: salesPerson_id === -1 ? undefined : salesPerson_id,
          orderByCols: {interactSort},
          active:activeStatus ? 1 : 0
        },
      });
      if (res.code === 200) {
        setBrands(res.data);
        setAllBrands(res.data);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (parseInt(previousDay) === 0) {
      fetchBrands();
    } else {
      const now = new Date();
      now.setHours(0, 0, 0, 0); 
  
      const startTime = Math.floor(now.getTime() / 1000) - (parseInt(previousDay) * 86400);
      const endTime = startTime + 86400;
      const filteredBrands = allBrands.filter(brand => {
        const timestamp = brand.interaction_date;
        return timestamp >= startTime && timestamp < endTime;
      });
      setBrands(filteredBrands);

    }
  }, [previousDay]);
  
  useEffect(() => {
    fetchBrands();
  }, [searchWord, salesPerson_id, interactSort, activeStatus]);

  const generateSelectOptions = () => {
    let selectOptions = [];
    brands.map((brand) =>
      selectOptions.push({ label: brand.brand_name, value: brand.brand_id })
    );
    setBrandOptions(selectOptions);
  };
  const onSlSalesChange = (selected) => {
    setSelectedList(
      selected || []
    );
    localStorage.setItem("selectedSalesList", JSON.stringify(selected.map(item => item.value)))
    // if(salesPerson_id !== -1){
      setSalesPerson_id( salesUsersList?.length > 1
        ? selected[selected.length - 1]?.value || -1
        : -1)
        document
        .getElementById(`${selected[selected.length - 1]?.value}`)
        .scrollIntoView({ behavior: "smooth" });
    // } 
    document.getElementById(`${selected[selected.length -1]?.value}`).scrollIntoView({ behavior: 'smooth' });
  };
  const salesTabChange = async (sales_id) => {
    setBrands([]);
    setSalesPerson_id(sales_id)
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const handleRemove = (event) => {
    const sales_person_id = event;
    let tempArray = selectedList.filter(item => item.value !== +sales_person_id)
    setSelectedList(tempArray)
    let slideToId = salesPerson_id
    if(+sales_person_id === salesPerson_id){
      setSalesPerson_id(tempArray[0].value)
      slideToId = tempArray[0].value
    }
    localStorage.setItem("selectedSalesList", JSON.stringify(tempArray.map(item => item.value)))
    document?.getElementById(slideToId)?.scrollIntoView({ behavior: "smooth" });
  }

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const closeUsersFilter = () => {
      try {
        if (selectedList.length === 0) { Toast("error", "Select Atleast a User") }
        else { setSalesPerson_id(selectedList[0].value); setShowUsersFilter(false) }
      } catch (error) {
        console.error("Error @ closeUsersFilter", error)
      }
    }

  return (
    <>
      <div className="acc-theme">
      <div className="d-flex justify-between my-2 bg-white account-management">
        <h4>Account Management</h4>
        <aside class="form-check d-flex gap-2 items-end filters">
        <div class="form-check form-switch active-filter">
        <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" checked={activeStatus} onChange={()=>{setActiveStatus(!activeStatus)}} />
        <label class="form-check-label" for="flexSwitchCheckChecked">{activeStatus ? 'Active' : 'Inactive'}</label>
      </div>
          <SlSelect value={previousDay} className="w-[150px]" label="Days Ago" onSlChange={((e) => setPreviousDay(e.target.value))}>
            <SlOption value={'0'}>All</SlOption>
            <SlOption value={'1'}>Previous Day</SlOption>
            <SlOption value={'2'}>Two Days ago</SlOption>
            <SlOption value={'3'}>Three Days ago</SlOption>
            <SlOption value={'4'}>Four Days ago</SlOption>
            <SlOption value={'5'}>Five Days ago</SlOption>
            <SlOption value={'6'}>Six Days ago</SlOption>
            <SlOption value={'7'}>Seven Days ago</SlOption>
          </SlSelect>
          {/* {salesUsersList?.length ? <div>
          <Select type="text"
          className=""
          name="sales_person_id"
          placeholder="Sales Person"
          value={selectedList}
          onChange={(selected) => {onSlSalesChange(selected)}}
          options={[ ...salesUsersList]}
          isMulti
        />
          </div> : null} */}
          {salesUsersList?.length > 1 ? <div className="select-sales-users ml-auto" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
          </div> : null}
        </aside>
        {/* <div className="w-full m-1 mobileOnly">
          <img
            src={filterSvg}
            className="ml-auto w-6"
            onClick={() => setShowFilter(true)}
            alt="filter"
          ></img>
        </div> */}
      </div>
     <SlTabGroup>
      {
        <SlTab
          onClick={() => {
            salesTabChange(-1);
          }}
          slot="nav"
          panel="general"
          active={salesPerson_id === -1}
        >
          {localStorage.getItem("name")}
        </SlTab>
      }
      {selectedList.map((item) => {
        return (
          <SlTab
            slot="nav"
            closable={selectedList.length > 1}
            onSlClose={() => handleRemove(item.value)}
            panel={item.value}
            onClick={() => {
              salesTabChange(item.value);
            }}
            active={salesPerson_id === item.value}
            id={`${item.value}`}
          >
            {item.label}
          </SlTab>
        );
      })}
    </SlTabGroup>
      <ScrollContainer>
        <div className="table-res mt-3">
          <div className="bg-gray-100 table-head acc_mange">
            <div class="column">S.NO</div>
            <div class="column min-w-[15rem]">Client Name</div>
            <div class="column">POC</div>
            <div class="column sortCol">Last Interaction {interactSort ? (
              <SlIcon
                library="lucide"
                name="chevron-up"
                className="text-black hover:cursor-pointer text-base"
                onClick={() => {setInteractSort(false);}}
              ></SlIcon>                
              ) : (
                <SlIcon
                  library="lucide"
                  name="chevron-down"
                  className="text-black hover:cursor-pointer text-base"
                  onClick={() => {setInteractSort(true); }}
                ></SlIcon>
              )}</div>
            <div class="column">Description</div>
            <div class="column sortCol">Status 
              {/* {statusSort ? (
              <SlIcon
                library="lucide"
                name="chevron-up"
                className="text-black hover:cursor-pointer text-base"
                onClick={() => {setStatusSort(false);}}
              ></SlIcon>                
              ) : (
                <SlIcon
                  library="lucide"
                  name="chevron-down"
                  className="text-black hover:cursor-pointer text-base"
                  onClick={() => {setStatusSort(true); setInteractSort(false);}}
                ></SlIcon>
              )} */}
              </div>
            <div class="column">Last Active</div>
            <div class="column">Interaction Details</div>
          </div>
          {brands?.length && !loader ? (
            <>
              {brands.map((brand, index) => {
                return (
                  <div class="table-row">
                    <div class="column">{index + 1}</div>
                    <div class="column inline30">
                      <div className="cLogo font-semibold capitalize d-flex gap-2 w-full items-center">
                        <sl-tooltip content={brand.brand_name}>
                          <img
                            src={
                              brand?.logo_url ||
                              getGenerateUrl(brand.brand_name)
                            }
                            className="h-6"
                            alt={brand.brand_name.slice(0, 3)}
                          />
                        </sl-tooltip>
                        <span
                          title={brand.brand_name}
                          className="w-1/2 truncate"
                        >
                          {brand.brand_name}
                        </span>
                      </div>
                      <div className="d-flex gap-2">
                        {brand.category && <span className="px-2 py-[2px] text-[10px] leading-3 bg-green-200 rounded-md">{brand.category}</span>}
                        {brand.brand_label && <span className={`px-2 py-[2px] text-[10px] leading-3 rounded-md  ${brand.brand_label === 1 ? 'bg-green-400' : brand.brand_label === 2 ? 'bg-orange-400' :'bg-orange-200' }`}>{brand.brand_label < 3 ? <SlIcon library="lucide" name={brand.brand_label === 1 ? 'chevrons-up' : brand.brand_label === 2 ? 'chevron-up' :'' }></SlIcon> : null}<span>{brandLabels.find(labelObj => labelObj.value === brand.brand_label).label}</span></span>} 
                        <span className="px-2 py-[2px] text-[10px] leading-3 bg-blue-200 rounded-md">
                        {brand.assigned_date
                          ? format(new Date(parseInt(brand.assigned_date)*1000), 'd-M-yyyy')
                          : 'Invalid Date'}
                      </span>

                      </div>
                    </div>
                    <div class="column inline70">
                      <AccordionSales data={brand.contacts} />
                    </div>
                    <div class="column shuffle-1">
                      {brand?.interaction_date ? (
                        <div
                          className={`d-flex gap-1 items-center font-semibold ${
                            calculateDaysAgo(brand?.interaction_date, true) <= 3
                              ? "green-interaction"
                              : calculateDaysAgo(
                                  brand?.interaction_date,
                                  true
                                ) <= 7
                              ? "yellow-interaction"
                              : "red-interaction"
                          }`}
                        >
                          <SlIcon
                            library="lucide"
                            name="clock-7"
                            className="font-bold"
                          />
                          <span>
                            {calculateDaysAgo(brand?.interaction_date)}
                          </span>
                        </div>
                      ) : (
                        "-"
                      )}
                    </div>
                    <div class="column descript" title={brand.description}>
                      {brand?.description}
                    </div>
                    <div class="column desktopOnly">
                      {brand?.interaction_status ? (
                        <p
                          className={` d-flex justify-between items-center gap-1 ${
                            brand?.interaction_status <= 5
                              ? "blue-status"
                              : brand?.interaction_status === 6
                              ? "green-status"
                              : "red-status"
                          }`}
                        >
                          {brand?.interaction_status > 5 ? (
                            <SlIcon
                              library="lucide"
                              name={
                                brand?.interaction_status <= 5
                                  ? "-"
                                  : brand?.interaction_status === 6
                                  ? "star"
                                  : "thumbs-down"
                              }
                            ></SlIcon>
                          ) : null}
                          {InteractionStatus[brand?.interaction_status]}
                        </p>
                      ) : (
                        "- "
                      )}
                    </div>
                    <div class="column shuffle-2">
                      <>
                      {brand?.last_active_date ?(
                        <div
                          className={`d-flex gap-1 items-center font-semibold ${
                            calculateDaysAgo(brand?.last_active_date, true) <= 3
                              ? "green-interaction"
                              : calculateDaysAgo(
                                  brand?.last_active_date,
                                  true
                                ) <= 7
                              ? "yellow-interaction"
                              : "red-interaction"
                          }`}
                        >
                          <SlIcon
                            library="lucide"
                            name="file"
                            className="font-bold"
                          ></SlIcon>
                          <span>
                            {calculateDaysAgo(brand?.last_active_date)}
                          </span>
                        </div>):"-"}
                        {brand?.last_active_date_w2n ?( <div
                          className={`d-flex gap-1 items-center font-semibold ${
                            calculateDaysAgo(brand?.last_active_date_w2n, true) <= 3
                              ? "green-interaction"
                              : calculateDaysAgo(
                                  brand?.last_active_date,
                                  true
                                ) <= 7
                              ? "yellow-interaction"
                              : "red-interaction"
                          }`}
                        >
                          <img src={W2nSvg} alt="w2n" className="w-6 h-6"/>
                          <span>
                            {calculateDaysAgo(brand?.last_active_date_w2n)}
                          </span>
                        </div>
                      ) : (
                        "-"
                      )}
                      </>
                    </div>
                    <div class="column accActions">
                      <div class="mobileOnly fitContent">
                        {brand?.interaction_status ? (
                          <p
                            className={` d-flex justify-between items-center gap-1 ${
                              brand?.interaction_status <= 5
                                ? "blue-status"
                                : brand?.interaction_status === 6
                                ? "green-status"
                                : "red-status"
                            }`}
                          >
                            {brand?.interaction_status > 5 ? (
                              <SlIcon
                                library="lucide"
                                name={
                                  brand?.interaction_status <= 5
                                    ? "-"
                                    : brand?.interaction_status === 6
                                    ? "star"
                                    : "thumbs-down"
                                }
                              ></SlIcon>
                            ) : null}
                            {InteractionStatus[brand?.interaction_status]}
                          </p>
                        ) : (
                          "- "
                        )}
                      </div>
                      <div className="d-flex items-start gap-2 mobileShuffle">
                        {((salesPerson_id === - 1) && activeStatus) ? <>
                        <sl-tooltip content="Add Poc">
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              setAddPoc(true);
                              setBrand({
                                name: brand.brand_name,
                                brand_id: brand.brand_id,
                              });
                            }}
                          >
                            <img src={recordSvg} alt="mikeSvg"></img>
                            <span className="text-[10px] text-[#4952FA]">
                              Add Poc
                            </span>
                          </div>
                        </sl-tooltip>
                        <sl-tooltip content="Add Interaction">
                          <img
                            className="cursor-pointer"
                            src={callSvg}
                            alt="callSvg"
                            onClick={() => {
                              setAddInteraction(true);
                              setBrand({
                                name: brand.brand_name,
                                brand_id: brand.brand_id,
                              });
                            }}
                          ></img>
                        </sl-tooltip>
                        <sl-tooltip content="Add Remainder">
                          <img
                            className="cursor-pointer"
                            src={bellSvg}
                            alt="bellSvg"
                            onClick={() => {
                              setAddRemainder(true);
                              setBrand({
                                brand_id: brand.brand_id,
                                name: brand.brand_name,
                              });
                            }}
                          ></img>
                        </sl-tooltip>
                        <span className="h-4 w-[1px]  bg-gray-300"></span>
                        <sl-tooltip content="Add Competitor Campaign">
                          <img
                            className="cursor-pointer"
                            src={mikeSvg}
                            alt="mikeSvg"
                            onClick={() => {
                              setAddCampaign(true);
                              setBrand({
                                name: brand.brand_name,
                                brand_id: brand.brand_id,
                              });
                            }}
                          ></img>
                        </sl-tooltip>
                        <span className="h-4 w-[1px]  bg-gray-300"></span>
                        </> : null}
                        <sl-tooltip content="History">
                          <img
                            src={historySvg}
                            alt="history"
                            className="cursor-pointer"
                            onClick={() => {
                              setHistory(true);
                              setBrand({
                                name: brand.brand_name,
                                brand_id: brand.brand_id,
                              });
                              generateSelectOptions();
                            }}
                          />
                        </sl-tooltip>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : !brands?.length && !loader ? (
            <NoDataFound colspan="8" />
          ) : (
            <TableLoader colspan="8" />
          )}
        </div>
      </ScrollContainer>
      </div>
      {addPoc && (
        <AddPOC
          brand={brand}
          show={addPoc}
          loadData={fetchBrands}
          setShow={setAddPoc}
        ></AddPOC>
      )}
      {addCampaign && (
        <CampaignInfo
          brand={brand}
          show={addCampaign}
          setShow={setAddCampaign}
        ></CampaignInfo>
      )}
      {addInteraction && (
        <Interaction
          brand={brand}
          show={addInteraction}
          loadData={fetchBrands}
          setShow={setAddInteraction}
        ></Interaction>
      )}
      {addRemainder && (
        <AddRemainder
          brand={brand}
          show={addRemainder}
          loadData={fetchBrands}
          setShow={setAddRemainder}
        ></AddRemainder>
      )}
      {history && (
        <InteractionHistory
          show={history}
          setShow={setHistory}
          brand={brand}
          sales={salesPerson_id}
          brandOptions={brandOptions}
        ></InteractionHistory>
      )}
      {/* <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => { }}
      // style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" checked={activeStatus} onChange={()=>{setActiveStatus(!activeStatus)}} />
          <label class="form-check-label" for="flexSwitchCheckChecked">{activeStatus ? 'Active' : 'Inactive'}</label>
        </div>
          <SlSelect value={previousDay} label="Days" onSlChange={((e) => setPreviousDay(e.target.value))} className="mb-3">
            <SlOption value={'0'}>All</SlOption>
            <SlOption value={'1'}>Previous Day</SlOption>
            <SlOption value={'2'}>Two Days ago</SlOption>
            <SlOption value={'3'}>Three Days ago</SlOption>
            <SlOption value={'4'}>Four Days ago</SlOption>
            <SlOption value={'5'}>Five Days ago</SlOption>
            <SlOption value={'6'}>Six Days ago</SlOption>
            <SlOption value={'7'}>Seven Days ago</SlOption>
          </SlSelect>
          <div className="flex items-center gap-3 flex-wrap justify-between">
            {
              <aside class="flex flex-col">
                {salesUsersList?.length ? <div>
                  <Select type="text"
                    className=""
                    name="sales_person_id"
                    placeholder="Sales Person"
                    value={selectedList}
                    onChange={(selected) => { onSlSalesChange(selected) }}
                    options={[...salesUsersList]}
                    isMulti
                  />
                </div> : null}

              </aside>
            }
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer> */}
      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => closeUsersFilter()}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => closeUsersFilter()}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => closeUsersFilter()}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
    </>
  );
}

export default AccountManagement;
